// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hyjL","image":"Header_image__hFF2i","name":"Header_name__S4_gu","info":"Header_info__2wxPe","infoRow":"Header_infoRow__i2aJr"};